// extracted by mini-css-extract-plugin
module.exports = {"condition":"eWkw1aFW","removeText":"gwYkAnWu","trashIcon":"K7j_nyTC"};